import type { Transition } from 'motion/react';

/**
 * KAIZEN Remote Motion Contract
 *
 * Motion communicates interaction/state.
 * It must never replace the approved visual system.
 */

export const kaizenNavTransition: Transition = {
  type: 'spring',
  stiffness: 280,
  damping: 30,
  mass: 0.55
};

export const kaizenMicroTransition: Transition = {
  type: 'spring',
  stiffness: 420,
  damping: 30,
  mass: 0.4
};

export const kaizenNumberTransition: Transition = {
  duration: 0.18,
  ease: [0.22, 1, 0.36, 1]
};

export const kaizenOverlayTransition: Transition = {
  duration: 0.16,
  ease: [0.22, 1, 0.36, 1]
};

export const kaizenDialogTransition: Transition = {
  type: 'spring',
  stiffness: 340,
  damping: 30,
  mass: 0.55
};

export const kaizenSheetTransition: Transition = {
  type: 'spring',
  stiffness: 320,
  damping: 32,
  mass: 0.62
};

export const kaizenAutoHeightTransition: Transition = {
  duration: 0.22,
  ease: [0.22, 1, 0.36, 1]
};

export const kaizenStateTransition: Transition = {
  duration: 0.16,
  ease: [0.22, 1, 0.36, 1]
};